import apiClient from "./apiClient";

export const fetchChatHistory = async () => {
  try {
    const response = await apiClient.get("/chat/chat_history");
    return response.data;
  } catch (error) {
    if (
      error.response &&
      error.response.data &&
      error.response.data.error === "Chat session not found"
    ) {
      console.warn("User has not started a chat session yet.");
      return null;
    } else {
      console.error("Error fetching chat history:", error);
      throw error;
    }
  }
};

export const sendUserQueryToAiModel = async (
  applicationId,
  role,
  messageContent,
  messageType
) => {
  try {
    const response = await apiClient.post("/chat/chat_with_ai", {
      application_id: applicationId,
      role: role,
      message_content: messageContent,
      message_type: messageType,
    });
    return response.data;
  } catch (error) {
    console.error("Error sending query to AI model:", error);
    throw error;
  }
};
